import { omit } from 'lodash-es';
import { AircraftMarkerListItem } from '@lp/features/RoutePlanner/types';
import {
  AircraftLogisticsResourceType,
  AviaLegTypes,
  CrewLogisticsResourceType,
  GroundLegTypes,
  LogisticsLegResourceType,
} from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';
import { CrewDutyView } from '@/api/apis/resources';

export const getCrewResources = (
  aircraftInfo: AircraftMarkerListItem,
  routeLegs: (AviaLegTypes | GroundLegTypes)[],
  resources: AircraftLogisticsResourceType[],
): LogisticsLegResourceType[] => {
  const aircraftId = aircraftInfo.id;
  const isAircraftInCase = resources.some((r) => r.resourceId === aircraftId);
  const tmdxAviaLegWithCurrentAircraft = routeLegs.find((leg) => {
    return leg.resources.some((r) => r.resourceId === aircraftId);
  });

  if (!isAircraftInCase || !tmdxAviaLegWithCurrentAircraft) {
    const crewDutyViews = aircraftInfo.availabilities[0]?.crewDutyViews || [];

    return crewDutyViews.map((item) => ({
      resourceId: item.crew.id,
      resourceType: CaseResourceType.Crew,
    }));
  }

  return tmdxAviaLegWithCurrentAircraft.resources.filter((r) => r.resourceType === CaseResourceType.Crew);
};

export const convertCrewViewToCrewResources = (crewDutyViews: CrewDutyView[]): CrewLogisticsResourceType[] => {
  return crewDutyViews.map(
    (item) =>
      ({
        ...omit(item.crew, ['id', 'phone']),
        phoneNumber: item.crew.phone || '',
        resourceId: item.crew.id,
        resourceType: CaseResourceType.Crew,
      }) as CrewLogisticsResourceType,
  );
};
